import { memo } from "react";
import { IFacilityReitItem } from "..";
import FacilityItem from "./FacilityItem";
import styles from "./styles.module.scss";

interface IFacilityItemList {
  list: IFacilityReitItem[];
  isLoading: boolean;
  onClick: (id: number) => void;
}

const FacilityItemList = ({ list, onClick }: IFacilityItemList) => {
  return (
    <div className={styles.facilityItemList}>
      <div className={styles.facilityItemList__container}>
        <div className={styles.facilityItemList__address}>
          <b>
            <span> {list[0].address}</span>
          </b>
        </div>
        {list.map((facilityItem) => {
          return (
            <div
              className={styles.facilityItemList__item}
              key={facilityItem.id}
            >
              <FacilityItem
                {...facilityItem}
                key={facilityItem.id}
                onClick={(id: number) => onClick(id)}
              />
            </div>
          );
        })}
      </div>
    </div>
  );
};

export default memo(
  FacilityItemList,
  (prev, current) => JSON.stringify(prev.list) === JSON.stringify(current.list)
);
